import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Price as ShowPrice } from '../../../../../../src/web/components';
import CurrentPageContext from '../../../../../contexts/CurrentPageContext';
import styles from './Price.scss';
import ApplicableFees from '../../../ApplicableFees';

export default class Price extends React.Component {
  static propTypes = {
    feeFilter: PropTypes.object,
    price: PropTypes.number,
    discountedPrice: PropTypes.number,
    renderPriceInCard: PropTypes.bool,
    renderPriceInCircle: PropTypes.bool,
    renderPriceInTier: PropTypes.bool,
    isSelectedUnitModal: PropTypes.bool,
    facility: PropTypes.shape({
      settings: PropTypes.object.isRequired,
    }).isRequired,
    priceDisplay: PropTypes.object,
  };

  static defaultProps = {
    feeFilter: undefined,
    price: undefined,
    discountedPrice: undefined,
    renderPriceInCard: undefined,
    renderPriceInCircle: undefined,
    renderPriceInTier: undefined,
    isSelectedUnitModal: undefined,
    priceDisplay: undefined,
  };

  static contextType = CurrentPageContext;

  renderPrice(
    price,
    className,
    shouldRenderOnce,
    haveDiscount,
    labelClassName,
    priceLabelText,
    breakPriceLabel,
  ) {
    const { facility, priceDisplay, renderPriceInTier } = this.props;
    const hidePricingDisplayCall = facility?.settings?.hidePricingDisplayCall;

    if (hidePricingDisplayCall && shouldRenderOnce) {
      return (
        <div className={cx(
          renderPriceInTier ? styles.callTextTieredPricing : styles.callText,
        )}
        >
          Call For Prices
        </div>
      );
    }

    if (hidePricingDisplayCall && !shouldRenderOnce) {
      return null;
    }

    const ceiledPrice = Math.ceil(price);
    const haveCents = ceiledPrice !== price;
    const {
      displayCents = false,
      showCents = false,
      showPricingLabel = false,
    } = priceDisplay || {};

    const shouldDisplayCents = (haveCents && displayCents) || showCents;
    return (
      <div className={
        showPricingLabel && (breakPriceLabel ? styles.priceContainerWithCents
          : styles.priceContainerWithoutCents)}
      >
        <ShowPrice
          element="div"
          className={className}
          value={price}
          decimals={shouldDisplayCents ? 2 : 0}
          priceDisplay={priceDisplay}
          data-testid="unitPrice"
        />
        {showPricingLabel && haveDiscount && (
          <div
            className={cx(
              labelClassName,
              breakPriceLabel ? styles.pricingLabelWithCents : styles.pricingLabel,
              'order-first',
            )}
          >
            {priceLabelText}
          </div>
        )}
      </div>
    );
  }

  render() {
    const { primaryColorClass, primaryColorBackgroundClass } = this.context;
    const {
      feeFilter,
      price,
      discountedPrice,
      renderPriceInCard,
      renderPriceInCircle,
      renderPriceInTier,
      isSelectedUnitModal,
      facility,
      priceDisplay,
    } = this.props;

    const isDiscounted = discountedPrice !== null && discountedPrice !== undefined;
    const hidePricingDisplayCall = facility?.settings?.hidePricingDisplayCall;
    const shouldRenderOnce = (hidePricingDisplayCall === true);
    const {
      displayCents = false,
      showPricingLabel = false,
    } = priceDisplay || {};
    const breakPriceLabel = displayCents === true;

    // Tier pricing
    if (renderPriceInTier) {
      return (
        <div className={styles.priceStyles}>
          <div className={styles.price}>
            {isDiscounted && this.renderPrice(price, styles.discountedTierPrice)}
          </div>
          {(
            <div className={styles.price}>
              {this.renderPrice(discountedPrice || price, `${styles.priceForTieredPricing}`, shouldRenderOnce)}
            </div>
          )}
        </div>
      );
    }

    // Theme three
    if (renderPriceInCard) {
      return (
        <div className={styles.priceStyles}>
          <div className={styles.price}>
            {isDiscounted && this.renderPrice(price, styles.standardPriceStyles)}
          </div>
          <div className={styles.price}>
            {this.renderPrice(discountedPrice || price, `${styles.priceForThemeThree} ${primaryColorClass}`, shouldRenderOnce)}
            <ApplicableFees
              facility={facility}
              feeFilter={feeFilter}
              feesLinkThemeClass={styles.applicableFeesLinkTheme}
              descriptionBoxClass={isSelectedUnitModal
                ? styles.descriptionBoxModal : styles.descriptionBoxTheme}
            />
          </div>
        </div>
      );
    }

    // Theme two
    if (renderPriceInCircle) {
      const priceStyle = isSelectedUnitModal
        ? styles.selectedUnitModalPriceTwo
        : styles.standardPriceThemeTwo;
      return (
        <>
          <div className={cx(styles.priceRoot, primaryColorBackgroundClass)}>
            {this.renderPrice(
              isDiscounted ? discountedPrice : price,
              isSelectedUnitModal ? styles.modalPriceThemeTwo : styles.priceThemeTwo,
              shouldRenderOnce,
            )}
            {isDiscounted && this.renderPrice(price, priceStyle)}
          </div>
          <ApplicableFees
            facility={facility}
            feeFilter={feeFilter}
            feesLinkThemeClass={styles.applicableFeesLinkThemeTwo}
            descriptionBoxClass={isSelectedUnitModal && styles.descriptionBoxModalTwo}
          />
        </>
      );
    }

    // Theme one
    return (
      <div className={styles.root}>
        {this.renderPrice(
          isDiscounted ? Number(discountedPrice) : price,
          cx(styles.price, primaryColorClass),
          shouldRenderOnce,
          isDiscounted,
          primaryColorClass,
          'Web Rate',
          breakPriceLabel,
        )}
        {isDiscounted && this.renderPrice(
          price,
          cx(
            !showPricingLabel && styles.standardPrice,
            showPricingLabel && (
              breakPriceLabel
                ? styles.standardPriceLabelWithCents
                : styles.standardPriceLabel
            ),
          ),
          undefined,
          isDiscounted,
          styles.standardPriceColor,
          'In Store',
          breakPriceLabel,
        )}
        <ApplicableFees
          facility={facility}
          feeFilter={feeFilter}
          feesLinkThemeClass={styles.applicableFeesLinkTheme}
          descriptionBoxClass={isSelectedUnitModal
            ? styles.descriptionBoxModal : styles.descriptionBoxTheme}
        />
      </div>
    );
  }
}
